import   React                 ,
       { useState              ,
         useEffect             }  from 'react';

import   classNames               from 'classnames';

import   styles                   from './BusinessDocumentSheet.module.scss';

import   Field                from '../../widget/inputs/Field';
import   FieldFile                from '../../widget/inputs/FieldFile';
import   WidgetFrame              from '../../widget/navigation/WidgetFrame';
import   Trigger                  from '../../widget/actuators/Trigger';


import { BusinessDocument           }  from '../../../dataTypes/legalStructureManagment/types';





type BusinessDocumentSheetProps = {
  onConfirm? : (businessDocument : BusinessDocument) => void
  onCancel?  : () => void
}

export const BusinessDocumentSheet = ({ onConfirm      ,
                                   onCancel       }: BusinessDocumentSheetProps) => {

  const [ name         , setName         ] = useState ( '' );
 // const [ fileType     , setFileType     ] = useState ( '' );
  const [ fileToUpload , setFileToUpload ] = useState<File|null> ( null );

  const [ messageName         ] = useState ( '' );
//  const [ messageFileType     , setMessageFileType     ] = useState ( '' );
  const [ messagefileToUpload ] = useState ( '' );

  useEffect(() => {

  }, []);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setName ( e.target.value )
  };

 /* const handleFileTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    setFileType ( e.target.value )
  };
*/
  const handleFileToUploadChange = (e: React.ChangeEvent<HTMLInputElement>, value: string | File) => {

    setFileToUpload ( value as File )
  };

  const handleCancelButtonClick = () => {
    if ( onCancel ) onCancel()
  }

  const handleValidateButtonClick = () => {

    const newBusinessDocument : BusinessDocument = {
      id           : 0,
      name         : name,
      fileName     : '',
      fileType     : '',
      creationDate : new Date() ,
	  fileToUpload : fileToUpload
    }

    if (onConfirm) onConfirm (newBusinessDocument)
  }

  return (

           <div className={classNames(styles.root)}>

               <p className={classNames(styles.title)}>
                 Ajout d'un document
               </p>

               <br/>

               <div className={classNames(styles.form)}>

                 <div className={classNames(styles.fileToUpload)}>
                   <WidgetFrame name               = "Fichier : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messagefileToUpload}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <FieldFile onChange = {handleFileToUploadChange} />
                   </WidgetFrame>
				 </div>

                 <div className={classNames(styles.name)}>
                   <WidgetFrame name               = "Nom : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageName}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field  type     = "text"
                             value    = {name}
                             onChange = {handleNameChange} />
                   </WidgetFrame>
				 </div>
				 {/*
                 <div className={classNames(styles.fileType)}>
                   <WidgetFrame name               = "Type : "
                                labelTextPosition  = "right"
                                labelBlockPosition = "left"
					            error              = {messageFileType}
                                classNameGrid      = {classNames(styles.grid_info)} >
                     <Field  type     = "text"
                             value    = {fileType}
                             onChange = {handleFileTypeChange} />
                   </WidgetFrame>
				 </div>
				 */}
                 <div className={classNames(styles.buttons)}>
                   <div className={classNames(styles.buttons_block)}>
                        <>
                          <Trigger name="Annuler" onClick={handleCancelButtonClick} variant="tailwind2" />
                          &nbsp;&nbsp;&nbsp;
                          <Trigger name="Ajouter" onClick={handleValidateButtonClick} variant="tailwind2" />
                        </>
                  </div>
                 </div>

               </div>

           </div>

         );
};


export default BusinessDocumentSheet;
